import { render, staticRenderFns } from "./LtkHeaderNavItems.vue?vue&type=template&id=10d39ae9&scoped=true"
import script from "./LtkHeaderNavItems.vue?vue&type=script&lang=ts"
export * from "./LtkHeaderNavItems.vue?vue&type=script&lang=ts"
import style0 from "./LtkHeaderNavItems.vue?vue&type=style&index=0&id=10d39ae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d39ae9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,LtkHeaderMenuItems: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkHeader/LtkHeaderMenuItems.vue').default,CMenu: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CMenu/CMenu.vue').default,CToolbarItems: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CToolbar/CToolbarItems.vue').default})
